import css from 'styled-jsx/css';

export default css`
  :global(.Post__cover) {
    order: -1;
    margin: 0 -1rem 1.5rem;
  }
`;
